<template>
  <div class="additional-information-card">
    <b-tabs v-model="tabIndex">
      <b-tab
        v-for="(tab, index) in diagnostics"
        :key="index"
        :title="$t(`engineering.final-gradient.${tab.name}`)"
      >
        <component
          :is="tab.component"
          :winding="tab.winding"
        />
      </b-tab>
    </b-tabs>
  </div>
</template>

<script>
import AdditionalInformationTab from './cardTabs/AdditionalInformationTab';
import MeasurementCalculationSensorTab from './cardTabs/MeasurementCalculationSensorTab';

export default {
  name: 'AdditionalInformationCard',
  components: {
    AdditionalInformationTab,
    MeasurementCalculationSensorTab,
  },
  props: {
    winding: {
      type: Object,
      default: () => ({}),
    },
  },
  data: () => ({
    tabIndex: 0,
  }),
  computed: {
    diagnostics() {
      const { winding } = this;
      return [
        {
          name: 'measurement-calculation-sensor',
          component: MeasurementCalculationSensorTab,
          winding: winding.measurementsSensorCalculations,
        },
        {
          name: 'additional-information',
          component: AdditionalInformationTab,
          winding: winding.additionalInformation,
        },
      ];
    },
  },
};
</script>

<style lang="sass" scoped>
@import src/styles/defaults/mixins
@import src/styles/defaults/variables

.additional-information-card
  min-height: 255px
  width: 100%

::v-deep
  .tab-pane
    background-color: var(--color-background-regular) !important
    min-height: 215px
    border: 1px solid var(--color-border-dark) !important
  .nav-tabs
    border-bottom: 1px solid var(--color-border-dark) !important
  .nav-link.active
    background-color: var(--color-background-regular)
</style>
